/* import __COLOCATED_TEMPLATE__ from './subunit-search-input.hbs.js'; */
var _dec, _dec2, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed } from '@ember/object';
import Component from '@ember/component';
import { isEmpty } from '@ember/utils';
import { debounce } from '@ember/runloop';

/**

## SubunitSearchInput

Input to search and select subunits

### Params
@param {Array<Subunit>} subunits - Subunits to select from to assign device
@param {Action} onSubunitChange - Action to call when setting subunit

*/
const INPUT_DEBOUNCE_TIME = 150;
let SubunitSearchInput = (_dec = computed('subunits.@each.nickname').readOnly(), _dec2 = computed('sortedSubunits.@each.nickname').readOnly(), _class = class SubunitSearchInput extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, 'data-test-subunit-search-input', true);
    _defineProperty(this, "value", null);
    _defineProperty(this, "lastSelectedValue", null);
    _defineProperty(this, "searchText", '');
  }
  init() {
    super.init();
    this.set('options', this.allSubunitOptions);
  }
  get sortedSubunits() {
    return this.subunits.sort((a, b) => a.nickname.localeCompare(b.nickname));
  }
  get allSubunitOptions() {
    return this.sortedSubunits.map(unit => {
      return {
        label: unit.nickname,
        value: unit
      };
    });
  }
  filterOptions() {
    /*
       NB: setting `device.subunit` to null here is a workaround for an interaction where
        1. The user selects an option
       2. They type something else into the search box
       3. They click create
       4. The device creation is successful and uses the selected option
        Since we're not sure if the user actually wanted to change the location and just forgot to select the option,
       this makes sure that validations fail when that happens. The value / label will then snap back to the previously
       selected option ( this happens in dropdownClosed() ).
    */
    this.onSubunitChange(null);
    const options = this.options;
    const text = this.searchText;
    const filter = text.toLowerCase();
    const substringMatches = options.filter(option => option.label.toLowerCase().includes(filter));
    this.set('options', substringMatches);
  }
  inputCancelled() {
    this.set('options', this.allSubunitOptions);
  }
  dropdownClosed() {
    this.set('options', this.allSubunitOptions);
    const subunit = this.lastSelectedValue;
    this.onSubunitChange(subunit);

    // Refresh the label value, as it gets cleared when the user types something
    if (!isEmpty(subunit)) {
      const nickname = subunit.nickname;
      this.set('value', {
        value: subunit,
        label: nickname
      });
    } else {
      this.set('value', {
        value: null,
        label: null
      });
    }
  }
  onInput(value) {
    const subunits = this.allSubunitOptions;
    if (isEmpty(value)) {
      this.set('options', subunits);
      return;
    }
    const inputLength = value.length;
    if (this.searchText.length > inputLength) {
      this.set('options', subunits);
    }
    this.set('searchText', value);
    debounce(this, this.filterOptions, INPUT_DEBOUNCE_TIME, false);
  }
  onSelect(option) {
    if (isEmpty(option) || isEmpty(option.value)) {
      this.onSubunitChange(null);
    } else {
      this.onSubunitChange(option.value);
      // Hold on to the last legitimate selection
      this.set('lastSelectedValue', option.value);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "sortedSubunits", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "sortedSubunits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allSubunitOptions", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "allSubunitOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inputCancelled", [action], Object.getOwnPropertyDescriptor(_class.prototype, "inputCancelled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dropdownClosed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dropdownClosed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSelect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelect"), _class.prototype), _class);
export { SubunitSearchInput as default };